import { buildScopedI18n } from '../../utils/buildScopedI18n';
import rcEsCL from './locales/es-CL.json';
import rcEnUS from './locales/en-US.json';
import rcPtBR from './locales/pt-BR.json';

export const reportCreatorI18n = buildScopedI18n({
  esCL: rcEsCL,
  enUS: rcEnUS,
  ptBR: rcPtBR,
});
